/**
 * Ad attribution captured at landing. Every field is a plain string so the snapshot
 * survives a JSON round trip through storage and the marketing site's cookie unchanged.
 */
export interface AttributionSnapshot {
  /** Google Ads click id. Absent on iOS traffic, which carries gbraid/wbraid instead. */
  gclid: string;
  gbraid: string;
  wbraid: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
}

/** The query/cookie keys an AttributionSnapshot is built from, in payload order. */
export const ATTRIBUTION_KEYS = [
  'gclid',
  'gbraid',
  'wbraid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const satisfies readonly (keyof AttributionSnapshot)[];

/**
 * A single row appended by `POST shiftat.sa/api/sheets`. The consumer is a spreadsheet,
 * so every field is a non-optional string — a missing value is `''`, never omitted, or
 * the columns shift.
 */
export interface ConversionPayload {
  gclid: string;
  conversion_name: string;
  conversion_time: string;
  conversion_value: string;
  conversion_currency: string;
  keyword: string;
  campaign: string;
  source: string;
  medium: string;
  job_type: string;
  company: string;
  firstname: string;
  email: string;
  mobilephone: string;
  job_title: string;
  date: string;
}
